"use strict";

exports.__esModule = true;
exports.VARIANT = void 0;
var VARIANT = {
  danger: 'danger',
  success: 'success',
  warning: 'warning'
};
exports.VARIANT = VARIANT;